import type { NavItemProps } from "../types";

export const MAIN_NAV:  NavItemProps[] = [
  {
    "title": "Asuransi Mobil",
    "link": "/asuransi/mobil/",
    "childItems": [
      {
        "title": "Asuransi Mobil Terbaik",
        "link": "/asuransi/mobil/",
      },
      {
        "title": "Asuransi Mobil All Risk",
        "link": "/asuransi/all-risk/",
      },
      {
        "title": "Asuransi Mobil TLO",
        "link": "/asuransi/tlo/",
      },
      {
        "title": "Asuransi Mobil Syariah",
        "link": "/asuransi/mobil-syariah/",
      },
    ],
  },
  {
    "title": "Asuransi Kesehatan",
    "link": "/asuransi/kesehatan/",
    "childItems": [
      {
        "title": "Asuransi Kesehatan Terbaik",
        "link": "/asuransi/kesehatan/",
      },
      {
        "title": "Asuransi Kesehatan Keluarga",
        "link": "/asuransi/kesehatan-keluarga/",
      },
      {
        "title": "Asuransi Kesehatan Orangtua",
        "link": "/asuransi/kesehatan-orangtua/",
      },
      {
        "title": "Asuransi Penyakit Kritis",
        "link": "/asuransi/penyakit-kritis/",
      },
      {
        "title": "Hospital Cash Plan",
        "link": "/asuransi/hospital-cash-plan/",
      },
      {
        "title": "Asuransi Melahirkan",
        "link": "/asuransi/melahirkan/",
      },
      {
        "title": "Asuransi Rawat Jalan",
        "link": "/asuransi/rawat-jalan/",
      },
      {
        "title": "Asuransi Gigi",
        "link": "/asuransi/gigi/",
      },
      {
        "title": "Asuransi Kesehatan Syariah",
        "link": "/asuransi/kesehatan-syariah/",
      }
    ],
  },
  {
    "title": "Asuransi Jiwa",
    "link": "/asuransi/jiwa/",
    "childItems": [
      {
        "title": "Asuransi Jiwa Terbaik",
        "link": "/asuransi/jiwa/",
      },
      {
        "title": "Asuransi Dwiguna",
        "link": "/asuransi/dwiguna/",
      },
      {
        "title": "Asuransi Jiwa Syariah",
        "link": "/asuransi/jiwa-syariah/",
      },
    ],
  },
  {
    "title": "Lainnya",
    "link": "/#/",
    "childItems": [
      {
        "title": "Asuransi Karyawan",
        "link": "/asuransi/karyawan/",
      },
      {
        "title": "Asuransi Motor",
        "link": "/asuransi/motor/",
      }
    ],
  },
  {
    "title": "Rekan",
    "link": "/#/",
    "childItems": [
      {
        "title": "Sompo service by Roojai",
        "link": "/asuransi/mobil-sompo/",
      },
      {
        "title": "Mega Insurance",
        "link": "/asuransi/mobil-mega-insurance/",
      },
      {
        "title": "Astra Garda Oto",
        "link": "/asuransi/mobil-garda-oto/",
      },
      {
        "title": "MAG",
        "link": "/asuransi/mobil-mag/",
      },
      {
        "title": "KB Insurance",
        "link": "/asuransi/kb-insurance/",
      },
      {
        "title": "Simas Insurtech",
        "link": "/asuransi/simas-insurtech/",
      },
      {
        "title": "ACA",
        "link": "/asuransi/mobil-aca/",
      },
      {
        "title": "Zurich Syariah",
        "link": "/asuransi/zurich-syariah/",
      },
      {
        "title": "Staco Mandiri",
        "link": "/asuransi/staco-mandiri/",
      },
      {
        "title": "Lippo General Insurance",
        "link": "/asuransi/kesehatan-lippo/",
      },
      {
        "title": "AXA Insurance",
        "link": "/asuransi/kesehatan-axa/",
      },
    ],
  },
  {
    "title": "Artikel & Tips",
    "link": "https://lifepal.co.id/media/",
    "childItems": [
      {
        "title": "Mengerti Asuransi",
        "link": "/media/apa-itu-asuransi/",
        "childItems": [
          {
            "title": "Polis Asuransi",
            "link": "/media/polis-asuransi/",
          },
          {
            "title": "Premi Asuransi",
            "link": "/media/apa-itu-premi-asuransi/",
          },
          {
            "title": "Jenis Asuransi",
            "link": "/media/jenis-asuransi/",
          },
          {
            "title": "Risiko Asuransi",
            "link": "/media/risiko-asuransi/",
          },
          {
            "title": "Klaim Asuransi",
            "link": "/media/klaim-asuransi/",
          }
        ],
      },
      {
        "title": "Tips Memilih Asuransi ",
        "link": "/media/cara-memilih-perusahaan-asuransi-yang-aman-dan-ideal/",
        "childItems": [
          {
            "title": "Rekomendasi Asuransi Mobil ",
            "link": "/media/asuransi-mobil-yang-bagus-apa-pilih-mana/",
          },
          {
            "title": "Rekomendasi Asuransi Kesehatan",
            "link": "/media/asuransi-kesehatan-rawat-jalan-dan-inap/",
          },
          {
            "title": "Perbedaan All Risk dan TLO",
            "link": "/media/beda-benefit-tlo-risk-dan-kombinasi-plus-cara-hitung-preminya/",
          },
          {
            "title": "Rate Asuransi Mobil",
            "link": "https://lifepal.co.id/media/rate-asuransi-mobil/",
          },
          {
            "title": "Jiwa Berjangka vs Seumur Hidup",
            "link": "/media/term-life/",
          }
        ],
      },
      {
        "title": "Artikel Lainnya",
        "link": "/media/",
        "childItems": [
          {
            "title": "Asuransi",
            "link": "/media/category/asuransi/",
          },
          {
            "title": "Asuransi Mobil",
            "link": "/media/category/asuransi-mobil/",
          },
          {
            "title": "Asuransi Kesehatan",
            "link": "/media/category/asuransi-kesehatan/",
          },
          {
            "title": "Kendaraan",
            "link": "/media/category/kendaraan/",
          },
          {
            "title": "Kesehatan",
            "link": "/media/category/kesehatan/",
          },
          {
            "title": "Tabungan",
            "link": "/media/category/tabungan/",
          },
          {
            "title": "Administrasi",
            "link": "/media/category/administrasi/",
          },
          {
            "title": "Ekonomi",
            "link": "/media/category/ekonomi/",
          },
          {
            "title": "Investasi",
            "link": "/media/category/investasi/",
          },
          {
            "title": "Kalkulator & Kuis",
            "link": "/media/category/kalkulator/",
          },
          {
            "title": "Ragam",
            "link": "/media/category/ragam/",
          },
          {
            "title": "Usaha",
            "link": "/media/category/usaha/",
          }
        ],
      }
    ],
  },
  {
    "title": "Layanan",
    "link": "#",
    "position": "right",
    "childItems": [
      {
        "title": "Tentang Lifepal",
        "link": "/tentang/",
      },
      {
        "title": "Dapatkan Penawaran",
        "link": "/penawaran/",
      },
      {
        "title": "Bantuan",
        "link": "/pusat-bantuan/",
      },
      {
        "title": "Ketentuan",
        "link": "/ketentuan/",
      }
    ],
  }
];